// extracted by mini-css-extract-plugin
module.exports = {"homeArticles":"HomeArticles_homeArticles__bIewm","homeArticlesCols":"HomeArticles_homeArticlesCols__3t8VL"};